import React from "react";
import { Container, Row } from "reactstrap";
import Pagination from "shared/components/Pagination";

const PaginationComponent = () => {
  return (
    <Container>
      <Row style={{ justifyContent: "space-evenly" }}>
        <Pagination totalPage={100} />
      </Row>
    </Container>
  );
};

export default PaginationComponent;
